import React from "react";
import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://www.anandapaudel.com.np";
export const SITE_NAME = "Ananda Paudel — Interior Designer & Furniture Specialist";
export const DEFAULT_OG = `${SITE_URL}/og-default.jpg`;

export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_OG,
  type = "website",
  noindex = false,
  jsonLd = null,
  children,
}) {
  const fullTitle = title
    ? `${title} | Ananda Paudel — Interior Designer, Nepal`
    : "Ananda Paudel | Interior Designer & Bespoke Furniture, Nepal";
  const url = `${SITE_URL}${path}`;
  const desc =
    description ||
    "Bespoke interior design and custom furniture in Nepal. 40+ years of expertise, factory-direct fabrication, end-to-end consulting, design and build.";

  const ldArray = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet prioritizeSeoTags>
      <html lang="en-NP" />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex ? (
        <meta name="robots" content="noindex,nofollow" />
      ) : (
        <meta
          name="robots"
          content="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"
        />
      )}
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="en_NP" />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {ldArray.map((ld, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(ld)}
        </script>
      ))}
      {children}
    </Helmet>
  );
}
